import styled from "styled-components";
import { GizmoContainerResize } from "../../utils";

const Indicator = styled(GizmoContainerResize)``;

export { Indicator };
